<template>
	<div id="underlying-funds-current-allocation">
		<div v-if="isAFISTargetDate" class="tab-container-top">
			<div
				@click="setActiveTab('strategies')"
				:class="{'active':isUnderlyingFundsActive}"
				class="tab"
			>
				<div :class="[isUnderlyingFundsActive ? 'white-arrow-down' : 'white-arrow-right']"/>
				<h3 class="header">
					Underlying Funds
					<slot name="superscript1"/>
				</h3>
			</div>
			<div
				@click="setActiveTab('allocation')"
				:class="{'active':isCurrentAllocationActive}"
				class="tab"
			>
				<h3 class="header">
					Current Allocation
					<slot name="superscript2"/>
				</h3>
			</div>
		</div>
		<div class="underlying-fund app">
			<h3 class="module-title" v-if="!isAFISTargetDate">Underlying Funds</h3>
			<slot name="superscript1" v-if="!isAFISTargetDate"/>
			<div v-if="hasSufficientData()">
				<div class="row">
					<div class="col-md-3 col-sm-4 col-xs-4">
						<img :src="widgetData.dataSet.base64ChartImage" class="chart" >
					</div>
					<div class="col-md-9 col-sm-8 col-xs-12">
						<table class="chart-legend">
							<tbody>
								<tr v-for="(objective, index) in getObjectives()" :key="`${index}-objective`">
									<th>
										<div class="each-row">
											<div :style="getColor(objective.Color)" class="colored-square"/>
											<span class="objective">
												<sticky-text-wrap
													v-if="objective.UnderlyingFundObjectiveWeb == 'Cash & equivalents in support of managed risk strategy'"
													:text-content="[
														{content: ['Cash & equivalents in support of managed risk']},
														{
															noWrap: true,
															content: [' strategy', {slotName: 'superscript2'}]
														}
													]"
												>
													<template #superscript2>
														<slot name="superscript2"/>
													</template>
												</sticky-text-wrap>
												<span v-else>{{ objective.UnderlyingFundObjectiveWeb }}</span>
											</span>
											<span class="total-value">{{ objective.UnderlyingObjectivePct }}%</span>
										</div>
										<div v-if="objective.UnderlyingFundName && isUnderlyingFundsActive">
											<div
												v-for="(fund, fundIndex) in getFunds(objective.UnderlyingFundObjectiveWeb)"
												:key="`${fundIndex}-fund`"
												class="each-row"
											>
												<span class="fund-name">
													<a :href="fund.url ? fund.url : getFundLink(fund.UnderlyingFundQuotronSymbol)">
														<span v-html="fundName(fund)"/>
													</a>
												</span>
												<span class="sub-value">{{ fund.UnderlyingFundPct }}%</span>
											</div>
										</div>
									</th>
								</tr>
							</tbody>
						</table>
						<div
							class="col-md-12 com-mod-level-2-disclosure"
						>As of {{ widgetData.dataSet.AsOfDate }} (updated monthly).</div>
						<div class="col-md-12">
							<div class="arrow-wrapper">
								<i class="icon icon-arrow-right" />
								<a class="com-mod-utility-link" :href="quarterlyHoldingsLink">QUARTERLY HOLDINGS</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="insufficientData">No data available at this time.</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'UnderlyingFunds',
	props: {
		/**
		 * Data object to display in the form:
		 * returns: [{ data: String, label: String }]
		 * composite: null
		 */
		widgetData: {
			type: Object,
			default: () => ({
				dataSet: [],
				SuperScriptAnchorList: [],
				StatisticsList: []
			})
		},
		vehicleId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			isCurrentAllocationActive: false,
			isUnderlyingFundsActive: true
		};
	},
	computed: {
		isAFISTargetDate() {
			return (
				this.widgetData.dataSet &&
				this.widgetData.dataSet.isAFISTargetDate
			);
		}
	},
	methods: {
		hasSufficientData() {
			let result = false;
			if (
				this.widgetData &&
				this.widgetData.dataSet &&
				this.widgetData.dataSet.Data &&
				this.widgetData.dataSet.Data.length > 0
			) {
				result = true;
			}
			return result;
		},
		fundName(fund) {
			let value = '';
			// UnderlyingFundTrademarkShort key does not exist if the value in the table the QID uses is undefined
			const trademarkShort = fund.UnderlyingFundTrademarkShort || '';

			if (trademarkShort === 'SM') {
				value = `${fund.UnderlyingFundName ||
					''}<span><sup>${trademarkShort}</sup></span>`;
			} else {
				value = `${fund.UnderlyingFundName ||
					''}<span style="font-size:1.3em">${trademarkShort}</span>`;
			}
			return value;
		},
		getObjectives() {
			const array = this.widgetData.dataSet.Data;
			const objectiveList = [
				...new Set(array.map(item => item.UnderlyingFundObjectiveWeb))
			];
			const finalObject = [];
			objectiveList.forEach(objectiveNameWeb => {
				const objective = array.filter(obj => {
					return obj.UnderlyingFundObjectiveWeb === objectiveNameWeb;
				});
				finalObject.push(objective[0]);
			});
			return finalObject;
		},
		getFunds(underlyingFundObjectiveWeb) {
			const array = this.widgetData.dataSet.Data;
			let finalObject = [];
			finalObject = array.filter(obj => {
				return (
					obj.UnderlyingFundObjectiveWeb ===
					underlyingFundObjectiveWeb
				);
			});
			//finalObject.push(objective[0]);
			return finalObject;
		},
		getFundLink(quotron) {
			const url = window.location.href;
			let result;
			if (url.indexOf('wd-appsa') > -1 || url.indexOf('markitqa') > -1) {
				result = `https://www.stg.capitalgroup.com/advisor/investments/fund/${quotron}`;
			} else {
				result = `https://www.capitalgroup.com/advisor/investments/fund/${quotron}`;
			}
			return result;
		},
		getColor(colorString) {
			const defaultColor = 'backgroundColor: #ffffff';
			if (colorString) {
				return `backgroundColor: #${colorString}`;
			}
			return defaultColor;
		},
		getSuperScriptAnchor(superscriptIndex) {
			if (
				this.widgetData &&
				this.widgetData.SuperScriptAnchorList &&
				this.widgetData.SuperScriptAnchorList.length > 0
			) {
				return this.widgetData.SuperScriptAnchorList[superscriptIndex];
			}
			return '';
		},
		getStatisticList(statisticListIndex) {
			if (
				this.widgetData &&
				this.widgetData.StatisticsList &&
				this.widgetData.StatisticsList.length > 0
			) {
				return this.widgetData.StatisticsList[statisticListIndex];
			}
			return [];
		},
		setActiveTab(tab) {
			if (tab === 'strategies') {
				this.isCurrentAllocationActive = false;
				this.isUnderlyingFundsActive = true;
			} else {
				this.isCurrentAllocationActive = true;
				this.isUnderlyingFundsActive = false;
			}
		}
	}
};
</script>
<style lang="less" scoped>
@import '~_css_/tabs.less';
@import '~_css_/variables';
.arrow-wrapper {
	display: inline-block;
	overflow: hidden;
	margin: 10px 0 10px 0;
	.icon-arrow-right::after {
		content: " ";
		font-size: 0.666em;
	}
}
.holdings-link {
	display: block;
	margin-left: 21px;
	width: 100%;
	margin-top: 25px;
	text-transform: uppercase;
	font-family: 'Avenir Next LT W01 Demi', Arial, sans-serif;
}

#underlying-funds-current-allocation {
	.module-border-top();
	margin-bottom: 15px;
	.tab {
		background-color: #999;
		background-image: linear-gradient(to bottom, #999, gray);
		color: #fff;
		cursor: pointer;
		display: inline-block;
		margin-bottom: 20px;
		padding: 15px 9px !important;
		position: relative;

		&.active {
			background-color: #e5e5e5;
			background-image: linear-gradient(to bottom, #e5e5e5, #fff);
			color: #000;
			cursor: default;
		}

		.header {
			margin-top: 0;
			margin-bottom: 0;
			font-size: 18px;
			font-family: 'Avenir Next LT W01 Demi', Arial, serif;
			display: inline-block;
		}
	}
	.tab-container-top .tab div:first-child {
		display: none;
	}
	.tab-container-bottom {
		display: none;
	}
	#underlying-funds,
	#current-allocation {
		display: flex;
		margin-bottom: 15px;
		img.chart {
			height: 98.5px;
			width: 98.5px;
			min-width: 98.5px;
			margin-right: 15px;
		}
		.data-list {
			margin-left: 25px;
			flex: 1;
			display: flex;
			flex-wrap: wrap;
			align-content: start;
			.table-content-category() {
				font-family: 'Avenir Next LT W01 Demi', Arial;
				font-size: 14px;
				.module-border-top();
				max-height: min-content;
				line-height: 22px;
				padding-top: 3px;
				margin-top: 3px;
			}
			.table-content-item() {
				font-family: AvenirNextLTW01-Regular, Arial;
				font-size: 14px;
				max-height: min-content;
				line-height: 22px;
			}
			.category {
				position: relative;
				flex-basis: 51%;
				flex-grow: 1;
				.table-content-category();
				.colored-square {
					position: absolute;
					left: -18px;
					top: 10px;
					background-color: green;
				}
			}
			.category-value {
				.table-content-category();
				flex-basis: 40px;
				padding-left: 5px;
			}
			.category-item {
				.table-content-item();
				flex-basis: 51%;
				flex-grow: 1;
			}
			.category-item-value {
				.table-content-item();
				padding-left: 5px;
				flex-basis: 40px;
			}
		}
	}
	.asOfDate {
		font-family: 'AvenirNextLTW01-Condens 721299', Arial;
		font-size: 12px;
		color: @gray;
		margin-top: 15px;
		margin-left: 140px;
	}
}
@media (max-width: 996px) {
	#underlying-funds-current-allocation {
		.tab-container-bottom {
			display: initial;
		}
		.as-of-date {
			margin-left: 0px;
		}
	}
}
@media (max-width: 480px) {
	.tab {
		width: 100%;
		&.active {
			background-color: #999;
			background-image: linear-gradient(to bottom, #999, gray);
			color: #fff;
		}
		& ~ .tab {
			margin-left: 0;
		}
	}

	#underlying-funds-current-allocation {
		#underlying-funds,
		#current-allocation {
			flex-wrap: wrap;
			img.chart {
				margin-bottom: 20px;
				margin-right: auto;
			}
		}
	}
}
</style>
